import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import { EventEx } from "@preferredMedical/Models/Misc/EventEx";
import { CustomState } from "@preferredMedical/Store/CustomState";
import React, { Component } from 'react';
import { connect } from "react-redux";
import { css } from "styled-components";


export interface CheckoutReviewAndSubmitShippingServiceWarningModalStyles {
    modal?: ModalPresentationProps;
    container?: GridContainerProps;
}

export const checkoutReviewAndSubmitShippingServiceWarningModalStyles: CheckoutReviewAndSubmitShippingServiceWarningModalStyles = {
    modal: {
        size: 800,
        cssOverrides: {
            modalTitle: css`
                padding: 10px 30px;
            `,
            modalContent: css`
                padding: 20px 30px;
            `,
        },
    },
    container: { gap: 10 },
}


const mapStateToProps = (state: CustomState) => {
    return {
        styles: checkoutReviewAndSubmitShippingServiceWarningModalStyles
    };
};

interface OwnProps {
    title: string;
    content: string;
    openEvent: EventEx;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

interface State {
    modalIsOpen: boolean;
}

class CheckoutReviewAndSubmitShippingServiceWarningModal extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            modalIsOpen: false,
        }
        this.props.openEvent.subscribe(() => {
            this.setState({modalIsOpen: true});
        })
        this.closeHandler = this.closeHandler.bind(this);
    }

    closeHandler() {
        this.setState({modalIsOpen: false});
    }

    render() {
        return (
            <Modal
                {...this.props.styles.modal}
                headline={this.props.title}
                isOpen={this.state.modalIsOpen}
                handleClose={this.closeHandler}
            >
                <GridContainer {...this.props.styles.container}>
                    <Typography>{this.props.content}</Typography>
                </GridContainer>
            </Modal>
        );
    }
}

export default connect(mapStateToProps)(CheckoutReviewAndSubmitShippingServiceWarningModal);